import { Divider, Drawer, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material"
import SidebarMenu from "./sidebar-menu"
import { sidebarWidth } from "../main-layout"
import { ganerateSidebarItems } from "./sidebar-item-ganerator"
import { Conditional, Stack } from "src/shared/components"
import miniLogoImg from "src/assets/images/logo-mini.png"
import logoWideImg from "src/assets/images/Logo-2.png"
import logoImg from "src/assets/images/logo.png"
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore"
import { Close } from "@mui/icons-material"
import { useGlobalConfig } from "src/shared/context/globalConfigContext"
import AccountPopOver from "./account-popover"
import { useMemo, useState } from "react"
export interface ISidebarItemCommon {
  href?: string
  icon: ReactNode | null
  title: string
}
export interface ISidebarItem extends ISidebarItemCommon {
  children?: ISidebarItemCommon[] | null
}

const Sidebar = () => {
  const theme = useTheme()
  const [accountAnchorEl, setAccountAnchorEl] = useState<HTMLButtonElement | null>(null)
  const { isSidebarOpen, sidebarClose } = useGlobalConfig()
  const sidebarItems = useMemo(() => ganerateSidebarItems({ theme }), [theme])
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <>
      <Drawer
        anchor="left"
        open={isMdUp ? true : isSidebarOpen}
        PaperProps={{
          sx: {
            background: theme.palette.background.default,
            width: isSidebarOpen ? sidebarWidth.wide : sidebarWidth.narrow,
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.standard
            }),
            flex: "auto"
          }
        }}
        onClose={() => sidebarClose()}
        variant={isMdUp ? "permanent" : "temporary"}
      >
        <Stack
          direction={"row"}
          height={"70px"}
          sx={{
            overflow: "hidden",
            position: "relative"
          }}
          alignItems="center"
          justifyContent={"center"}
        >
          <IconButton
            onClick={() => sidebarClose()}
            sx={{ display: { xs: "flex", md: "none" }, position: "absolute", top: 16, right: 10 }}
          >
            <Close />
          </IconButton>
          <img
            src={isSidebarOpen ? logoWideImg : miniLogoImg}
            style={{
              width: isSidebarOpen ? "150px" : "50px",
              transition: "width 0.3s ease, opacity 0.3s ease",
              opacity: isSidebarOpen ? 1 : 0.8,
              filter: theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"
            }}
            alt="img"
          />
        </Stack>
        <Divider />
        <SidebarMenu sidebarItems={sidebarItems} />
        <Divider />
        <Stack
          direction="row"
          alignItems={"center"}
          spacing={1}
          p={2}
          sx={{ height: "70px", ...(!isSidebarOpen && { cursor: "pointer" }) }}
          onClick={(e) => {
            if (!isSidebarOpen) setAccountAnchorEl(e.currentTarget as any)
          }}
        >
          <img
            src={logoImg}
            style={{
              width: "40px",
              filter: theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"
            }}
            alt="img"
          />
          <Conditional condition={isSidebarOpen}>
            <Stack mr={"auto"} width={"157px"}>
              <Typography
                variant="body2"
                fontWeight={700}
                color="text.primary"
                sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              >
                John Doe
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.disabled"
                sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              >
                John@doe.com
              </Typography>
            </Stack>
            <IconButton
              onClick={(e) => {
                e.stopPropagation()
                setAccountAnchorEl(e.currentTarget)
              }}
            >
              <UnfoldMoreIcon />
            </IconButton>
          </Conditional>
        </Stack>
      </Drawer>
      <AccountPopOver
        transformOrigin={{ horizontal: "left", vertical: "center" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        anchorEl={accountAnchorEl}
        open={Boolean(accountAnchorEl)}
        onClose={() => setAccountAnchorEl(null)}
      />
    </>
  )
}

export default Sidebar
